<template>
  <div class="content">
    <h1 class="content__title">Lista de Páginas</h1>
    <span class="content__details">Listado de páginas, crea páginas</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de Páginas</h2>
          <div class="main__results">
            <div class="result" v-if="pages === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!pages">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <div class="result" v-else v-for="(page, index) in pages" :key="index">
              <div class="result__data">
                <h2 class="result__title" v-text="'Título: ' + page.title_es"></h2>
                <p class="result__detail">Estatus: {{ page.status_id | status(statusList)}}</p>
              </div>
              <div class="result__options">
                <router-link class="btn btn__default btn--small" :to="{name: 'pageEdit', params: {id: page.id}}" > Editar</router-link>
                <button class="btn btn__caution btn--small" @click="deletePage(page.id)">Borrar</button>
              </div>
            </div>

          </div>
          <pagination v-if="pagination.pages !== null" :config="pagination"></pagination>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'pageNew'}">Nueva Página</router-link>
      </aside>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/api/request'
import pagination from '@/components/layout/pagination'
import confirmation from '@/components/layout/confirmation'
import {StatusList} from './moks'
export default {
  mixins: [httpService],
  components: {
    pagination,
    confirmation
  },
  data: function () {
    return {
      pages: 'loading',
      statusList: StatusList,
      confirm: false,
      pagination: {
        maxButtons: 8,
        results: null,
        pages: null
      },
      maxResults: 12,
      page: 1,
      id: null
    }
  },
  created: function () {
    this.page = this.$route.params.page
    this.getPages()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    '$route.path': function () {
      this.page = this.$route.params.page
      this.getPages()
    }
  },
  filters: {
    status: function (id, list) {
      let status = list.filter(element => id == element.id)
      return status[0].name
    }
  },
  methods: {
    deletePage: function (id) {
      this.confirm = true
      this.id = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        module: 'pages'
      }
      this.delete(this.id, httpRequest)
        .then(
          () => {
            this.getPages()
            this.$store.commit('notificate', {
              title: 'PÁGINA BORRADA',
              text: 'La página ha sido borrada correctamente.',
              type: 'success'
            })
          }
        )
    },
    getPages: function () {
      let httpRequest = {
        module: 'pages',
        params: '?fields=title_es,id,status_id&limit=' + this.maxResults + '&page=' + this.page + '&embed=pagination'
      }
      this.get(httpRequest)
        .then(
          pages => {
            this.pages = pages.data
            this.pagination.pages = pages.pagination.pages
            this.pagination.currentPage = pages.pagination.current_page
            this.pagination.results = pages.pagination.results
          }
        )
        .catch(
          () => {
            this.pages = null
            this.pagination.pages = null
            this.pagination.currentPage = null
            this.pagination.results = null
            if (this.page > 1) {
              this.$router.push({name: 'pageList', params: {page: this.page - 1}})
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>


// WEBPACK FOOTER //
// src/components/pages/list.vue